export const HCP_DATA = "HCP_DATA";
export const FILTER_HCPDATA = "FILTER_HCPDATA";
export const HCP_SELECTION = "HCP_SELECTION";
export const NEW_HCP = "NEW_HCP";
export const EDIT_HCP = "EDIT_HCP";
export const HCPS_COUNT = "HCPS_COUNT";
export const HCP_LOCKED_STATUS = "HCP_LOCKED_STATUS";
export const CLEAN_HCP = "CLEAN_HCP"

export const CLINICS_DATA = "CLINICS_DATA";
export const DELETE_CLINIC_HCPS = "DELETE_CLINIC_HCPS"

export const FILTER_CLINICSDATA = "FILTER_CLINICSDATA";
export const CLINICS_SELECTION = "CLINICS_SELECTION";
export const DELETE_CLINIC = "DELETE_CLINIC"
export const NEW_CLINIC = "NEW_CLINIC";
export const EDIT_CLINIC = "EDIT_CLINIC";
export const CLINICS_COUNT = "CLINICS_COUNT";
export const CLEAN_CLINIC = "CLEAN_CLINIC"


export const ADMINS_DATA = "ADMINS_DATA";
export const FILTER_ADMINSDATA = "FILTER_ADMINSDATA";
export const ADMINS_SELECTION = "ADMINS_SELECTION";
export const NEW_ADMIN = "NEW_ADMIN";
export const EDIT_ADMIN = "EDIT_ADMIN";
export const ADMINS_COUNT = "ADMINS_COUNT";
export const DELETE_ADMIN = "DELETE_ADMIN";
export const ADMIN_LOCKED_STATUS = "ADMIN_LOCKED_STATUS";
export const CLEAN_ADMIN = "CLEAN_ADMIN"

export const FILTER_REQUESTS_DATA = "FILTER_REQUESTS_DATA";
export const REQUESTS_DATA = "REQUESTS_DATA";
export const EDIT_Payment = "EDIT_Payment";
export const EDIT_Request = "EDIT_Request";
export const REQUESTS_COUNT = "REQUESTS_COUNT";
export const CLOSED_FILTER_REQUESTS_DATA = "CLOSED_FILTER_REQUESTS_DATA";
export const CLOSED_REQUESTS_DATA = "CLOSED_REQUESTS_DATA";
export const CLOSED_EDIT_Payment = "CLOSED_EDIT_Payment";
export const CLOSED_EDIT_Request = "CLOSED_EDIT_Request";
export const CLOSED_REQUESTS_COUNT = "CLOSED_REQUESTS_COUNT";

export const PATIENTS_DATA = "PATIENTS_DATA";
export const FILTER_PATIENTSDATA = "FILTER_PATIENTSDATA";
export const PATIENTS_SELECTION = "PATIENTS_SELECTION";
export const PATIENTS_COUNT = "PATIENTS_COUNT";
export const PATIENTS_STATUSES = "PATIENTS_STATUSES";
export const NEW_PATIENT = "NEW_PATIENT";
export const EDIT_PATIENT = "EDIT_PATIENT";
export const PATIENT_LOCKED_STATUS = "PATIENT_LOCKED_STATUS";
export const DELETE_PATIENT = "DELETE_PATIENT";
export const CLEAN_PATIENT = "CLEAN_PATIENT"

export const MEDIATOR_DATA = "MEDIATOR_DATA"
export const MEDIATOR_SELECTION = "MEDIATOR_SELECTION"
export const EDIT_MEDIATOR = "EDIT_MEDIATOR"
export const DELETE_MEDIATOR = "DELETE_MEDIATOR"
export const NEW_MEDIATOR = "NEW_MEDIATOR"
export const CLEAN_MEDIATOR = "CLEAN_MEDIATOR"
export const MEDIATORS_COUNT = "MEDIATORS_COUNT";
export const MEDIATOR_LOCKED_STATUS = "MEDIATOR_LOCKED_STATUS";

